var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllipsenotiadmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.999 20C15.9195 20 16.666 20.7465 16.666 21.667C16.6658 22.5873 15.9194 23.333 14.999 23.333C14.0787 23.333 13.3322 22.5873 13.332 21.667C13.332 20.7465 14.0785 20 14.999 20ZM14.999 13.333C15.9195 13.333 16.666 14.0795 16.666 15C16.666 15.9205 15.9195 16.667 14.999 16.667C14.0785 16.667 13.332 15.9205 13.332 15C13.332 14.0795 14.0785 13.333 14.999 13.333ZM14.999 6.66699C15.9194 6.66699 16.6658 7.41268 16.666 8.33301C16.666 9.25348 15.9195 10 14.999 10C14.0785 10 13.332 9.25348 13.332 8.33301C13.3322 7.41268 14.0787 6.66699 14.999 6.66699Z",
    fill: "#28303F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsenotiadmin);
export default __webpack_public_path__ + "static/media/ellipsenotiadmin.c3c4c952d640395982700623bbfb3e93.svg";
export { ForwardRef as ReactComponent };